import jQuery from 'jquery'

import moment from 'moment'
import localforage from 'localforage'
import uri from 'urijs'
import {sprintf, vsprintf} from 'sprintf'
import chroma from 'chroma-js'
import eventEmitter from 'wolfy87-eventemitter'
import interact from 'interactjs'
import pako from 'pako'
import sortable from 'sortablejs'
import peg from 'pegjs'
import palette from 'google-palette'
import qrCode from 'qrcodejs2'
import * as survey from 'survey-knockout'
import * as surveyEditor from 'surveyjs-editor'
import * as colorPicker from 'a-color-picker'

import 'bootstrap-slider'
import 'popper.js'
import 'bootstrap'

import 'jsplumb';


import 'datatables.net'
import 'jstree'

(function(global){
	//Allow both shorthand/full name
	global.$ = jQuery;
	global.jQuery = jQuery;
    global.colorPicker = colorPicker;
	global.moment = moment;
	global.localforage = localforage;
	global.URI = uri;
	global.sprintf = sprintf;
	global.vsprintf = vsprintf;
	global.chroma = chroma;
	global.EventEmitter = eventEmitter;
	global.interact = interact;
	global.pako = pako;
	global.Sortable = sortable;
	global.PEG = peg;
	global.palette = palette;
	global.QRCode = qrCode;
    //global.bootstrapSlider = bootstrapSlider;
	global.Survey = survey;
	global.SurveyEditor = surveyEditor;
	
	//Can als have been set by Resource loader script
	global.MDB = global.MDB || {};
	global.Operator = global.Operator || {};
})(window);
